import { useBookingRowsContext } from "PFApp/booking/parts/overview/context/booking_rows_context";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useMemo } from "react";

import { useBookingBarContext } from "../../booking_bar_provider";

export const useDurationBreakdown = (): Record<string, number> => {
  const { utc, formatISODate } = useDateFormatter();
  const { bookingsByRowKey } = useBookingRowsContext();
  const {
    bar: { id: bookingId, row, start, end }
  } = useBookingBarContext();
  const booking = bookingsByRowKey[row.key].find(({ id }) => id === bookingId);
  const { duration_breakdown: durationBreakdown = {} } = booking ?? {};
  return useMemo(() => {
    const endDate = utc(end);
    const iteratorDate = utc(start);
    const daysDiff = endDate.diff(iteratorDate, "days") + 1;
    const result = {};
    for (let i = 0; i < daysDiff; i++) {
      const currentDateFormatted = formatISODate(iteratorDate);
      result[currentDateFormatted] = durationBreakdown[currentDateFormatted] ?? 0;
      iteratorDate.add(1, "day");
    }
    return result;
  }, [durationBreakdown, start, end]);
};
